import ApiClient from './ApiClient';

class ListFoldersAPI extends ApiClient {
  constructor() {
    super('list_folders', { accountScoped: true });
  }
}

export default new ListFoldersAPI();
